import React, {useState} from 'react';
import './styles/Publications.css';
import {FaDownload, FaExternalLinkAlt, FaSearch} from 'react-icons/fa';

// Publications data structure - easily upgradable by adding new entries
const publicationsData = [
    {
        id: 1,
        title: "Teaming Up with Artificial Agents in Non-routine Analytical Tasks",
        authors: "Cominelli, L., Galatolo, F., Giannetti, C., Ciaccio, C., Dell'Orletta, F., Chaposkvi, P., Venturi, G.",
        journal: "Università di Pisa, Dipartimento di Economia e Management",
        year: 2024,
        abstract: "This paper examines how artificial agents contribute to team performance in non-routine analytical tasks, analyzing their impact on collaboration and decision-making.",
        doi: "",
        pdf: `${process.env.PUBLIC_URL}/papers/2024-314.pdf`,
        tags: ["human-AI collaboration", "team performance", "non-routine tasks"]
    },
    {
        id: 2,
        title: "Ethical AI Systems and Shared Accountability: The Role of Economic Incentives in Fairness and Explainability",
        authors: "Yoo, D.-H., Giannetti, C.",
        journal: "Proceedings of the 5th Italian Workshop on Explainable Artificial Intelligence, co-located with the 23rd International Conference of the Italian Association for Artificial Intelligence, Bolzano, Italy",
        year: 2024,
        abstract: "This paper explores the intersection of economic incentives, fairness, and explainability in AI systems, emphasizing the role of shared accountability in ethical AI deployment.",
        doi: "",
        pdf: `${process.env.PUBLIC_URL}/papers/paper3.pdf`,
        tags: ["ethical AI", "explainability", "fairness", "economic incentives"]
    },
    {
        id: 3,
        title: "Crowdfunding Success: Human Insights vs Algorithmic Textual Extraction",
        authors: "Giannetti, C., Mavillonio, M. S.",
        journal: "Technical Report",
        year: 2024,
        abstract: "This report investigates the comparative effectiveness of human insights and algorithmic textual extraction in predicting crowdfunding success, highlighting key factors influencing funding outcomes.",
        doi: "",
        pdf: `${process.env.PUBLIC_URL}/papers/2024-315.pdf`,
        tags: ["crowdfunding", "text analysis", "human vs AI"]
    },
    {
        id: 4,
        title: "Improving Small-Scale Large Language Models Function Calling for Reasoning Tasks",
        authors: "Manduzio, G. A., Galatolo, F. A., Cimino, M. G. C. A., Scilingo, E. P., Cominelli, L.",
        journal: "arXiv preprint arXiv:2410.18890",
        year: 2024,
        abstract: "This study introduces a novel framework for training smaller language models in function calling, focusing on specific logical and mathematical reasoning tasks. The approach employs an agent that interacts with a large-scale LLM to generate datasets of reasoning chains, which are then used to train smaller models using Reinforcement Learning from Human Feedback, specifically employing the Direct Preference Optimization technique. Experimental results demonstrate improved function calling abilities in smaller models, balancing the trade-off between model size and performance.",
        doi: "https://doi.org/10.48550/arXiv.2410.18890",
        pdf: `${process.env.PUBLIC_URL}/papers/2410.18890v1.pdf`,
        tags: ["function calling", "large language models", "reasoning tasks", "reinforcement learning"]
    },
    {
        id: 5,
        title: "Advanced Control of Humanoid Facial Robotics: A Deep Learning Approach to Inverse Kinematics",
        authors: "Manduzio, G. A., Galatolo, F., Cimino, M. G. C. A., Bruscia, M., Cominelli, L., Scilingo, E. P.",
        journal: "Authorea Preprints",
        year: 2024,
        abstract: "This paper presents a deep learning approach to inverse kinematics for advanced control of humanoid facial robotics, enhancing the precision and realism of facial expressions.",
        doi: "",
        pdf: `${process.env.PUBLIC_URL}/papers/IEEE_DLIK.pdf`,
        tags: ["humanoid robotics", "facial expression", "inverse kinematics", "deep learning"]
    },
    {
        id: 6,
        title: "An Overview On Large Language Models Across Key Domains: A Systematic Review",
        authors: "Bruscia, M., Manduzio, G. A., Galatolo, F. A., Cimino, M. G. C. A., Greco, A., Cominelli, L., Scilingo, E. P.",
        journal: "2024 IEEE International Conference on Metrology for eXtended Reality, Artificial Intelligence and Neural Engineering (MetroXRAINE)",
        year: 2024,
        pages: "125-130",
        publisher: "IEEE",
        abstract: "This systematic review explores the applications and advancements of large language models across various key domains, highlighting their impact and future prospects.",
        doi: "",
        pdf: `${process.env.PUBLIC_URL}/papers/An_Overview_On_Large_Language_Models_Across_Key_Domains_A_Systematic_Review.pdf`,
        tags: ["large language models", "systematic review", "applications"]
    },
    {
        id: 7,
        title: "A Facial Imitation Framework for the Simultaneous Face Control of a Virtual Avatar and a Humanoid Robot (short paper)",
        authors: "Bruscia, M., Manduzio, G. A., Cominelli, L., Scilingo, E. P.",
        journal: "AIRO@AI*IA",
        year: 2023,
        pages: "23-30",
        abstract: "This paper presents a framework for facial imitation that enables simultaneous control of both a virtual avatar and a humanoid robot, enhancing human-robot interaction through synchronized facial expressions.",
        doi: "",
        pdf: `${process.env.PUBLIC_URL}/papers/teaming-up-artificial-agents.pdf`,
        tags: ["facial imitation", "virtual avatar", "humanoid robot", "human-robot interaction"]
    },
    {
        id: 8,
        title: "Evaluating Large Language Models via Linguistic Profiling",
        authors: "Miaschi, A., Dell'Orletta, F., Venturi, G.",
        journal: "Proceedings of the 2024 Conference on Empirical Methods in Natural Language Processing",
        year: 2024,
        abstract: "Large Language Models (LLMs) undergo extensive evaluation against various benchmarks collected in established leaderboards to assess their performance across multiple tasks. However, to the best of our knowledge, there is a lack of comprehensive studies evaluating these models' linguistic abilities independent of specific tasks. In this paper, we introduce a novel evaluation methodology designed to test LLMs' sentence generation abilities under specific linguistic constraints. Drawing on the linguistic profiling' approach, we rigorously investigate the extent to which five LLMs of varying sizes, tested in both zero- and few-shot scenarios, effectively adhere to (morpho)syntactic constraints. Our findings shed light on the linguistic proficiency of LLMs, revealing both their capabilities and limitations in generating linguistically-constrained sentences.",
        doi: "10.18653/v1/2024.emnlp-main.166",
        pdf: `${process.env.PUBLIC_URL}/papers/evaluating_large_language_models_via_linguistic_profiling.pdf`,
        tags: ["LLMs", "linguistic profiling", "evaluation methodology", "sentence generation", "syntactic constraints"]
    },
    {
        id: 9,
        title: "Controllable Text Generation To Evaluate Linguistic Abilities of Italian LLMs",
        authors: "Ciaccio, C., Dell'Orletta, F., Miaschi, A., Venturi, G.",
        journal: "CLiC-it 2024: Tenth Italian Conference on Computational Linguistics",
        year: 2024,
        abstract: "State-of-the-art Large Language Models (LLMs) demonstrate exceptional proficiency across diverse tasks, yet systematic evaluations of their linguistic abilities remain limited. This paper addresses this gap by proposing a new evaluation framework leveraging the potentialities of Controllable Text Generation. Our approach evaluates the models' capacity to generate sentences that adhere to specific linguistic constraints and their ability to recognize the linguistic properties of their own generated sentences, also in terms of consistency with the specified constraints. We tested our approach on six Italian LLMs using various linguistic constraints.",
        doi: "",
        pdf: `${process.env.PUBLIC_URL}/papers/Controllable_Text_Generation_To_Evaluate_Linguistic_Abilities_of_italian_LLMs.pdf`,
        tags: ["LLMs", "linguistic constraints", "controllable text generation", "Italian language", "model evaluation"]
    }
];

function Publications() {
    const [searchTerm, setSearchTerm] = useState('');
    const [filter, setFilter] = useState('all');
    const years = [...new Set(publicationsData.map(pub => pub.year))].sort((a, b) => b - a);

    // Filter publications based on search term and year filter
    const filteredPublications = publicationsData.filter(pub => {
        const matchesSearch = pub.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pub.authors.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pub.abstract.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pub.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));

        const matchesFilter = filter === 'all' || pub.year.toString() === filter;

        return matchesSearch && matchesFilter;
    });

    return (
        <main className="publications">
            <h1 className="publications__title">Publications</h1>

            {/* Search and Filter */}
            <div className="publications__controls">
                <div className="publications__search">
                    <FaSearch className="search-icon"/>
                    <input
                        type="text"
                        placeholder="Search by title, author, or keywords..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="publications__filter">
                    <label htmlFor="year-filter">Filter by year:</label>
                    <select
                        id="year-filter"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    >
                        <option value="all">All Years</option>
                        {years.map(year => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Publications List */}
            <div className="publications__list">
                {filteredPublications.length > 0 ? (
                    filteredPublications.map(pub => (
                        <div className="publication__card" key={pub.id}>
                            <h2 className="publication__title">{pub.title}</h2>
                            <p className="publication__authors">{pub.authors}</p>
                            <p className="publication__journal">
                                <span className="journal-name">{pub.journal}</span>,
                                <span className="publication-year"> {pub.year}</span>
                            </p>

                            <div className="publication__abstract">
                                <h3>Abstract</h3>
                                <p>{pub.abstract}</p>
                            </div>

                            <div className="publication__tags">
                                {pub.tags.map((tag, index) => (
                                    <span className="publication__tag" key={index}>
                                        {tag}
                                    </span>
                                ))}
                            </div>

                            <div className="publication__links">
                                <a href={pub.doi} target="_blank" rel="noopener noreferrer"
                                   className="publication__link">
                                    <FaExternalLinkAlt/> DOI
                                </a>
                                <a href={pub.pdf} className="publication__link">
                                    <FaDownload/> PDF
                                </a>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="publications__empty">
                        <p>No publications found matching your search criteria.</p>
                    </div>
                )}
            </div>
        </main>
    );
}

export default Publications;
